import { call, put, select } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { RefreshPropertyHelper } from '../../../../ts/helpers/RefreshPropertyHelper';
import { IDataSourceBase } from '../../../../ts/models/IDataSourceInfo';
import { IRemoteRefreshScheduleInfo } from '../../../../ts/models/IRemoteRefreshScheduleInfo';
import { EditRemoteRefreshExpectedDurationAction } from '../../../../ts/services/EditRemoteRefreshExpectedDurationAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { ChangeRemoteExtractRefreshExpectedDurationAction } from '../../../actions/spaces/ChangeRemoteExtractRefreshExpectedDurationAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { selectSpaceInfoItem } from '../../../selectors/ContentSelectors';
import { ServiceLocator } from '../../../ServiceLocator';

export function* handleChangeRemoteExtractRefreshExpectedDurationAction(action: ChangeRemoteExtractRefreshExpectedDurationAction) {
  try {
    const datasource: IDataSourceBase = yield select(selectSpaceInfoItem);
    yield call(executeChangeRemoteExtractRefreshExpectedDurationAction, datasource, action.scheduleInfo);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeChangeRemoteExtractRefreshExpectedDurationAction(
  datasource: IDataSourceBase,
  item: IRemoteRefreshScheduleInfo
) {
  const editRemoteExtractRefreshExpectedDurationService =
    ServiceLocator.get<EditRemoteRefreshExpectedDurationAction>('EditRemoteRefreshExpectedDurationAction');
  const context = ServiceLocator.getAngularActionContext();
  return editRemoteExtractRefreshExpectedDurationService.execute(context, datasource, item);
}
